<template>
  <div class="platform-overview flex-box">
    <div class="title">化工材料行业PLM的平台概要</div>
    <div class="description">解决高分子、改性材料、涂料油漆、化工试剂等行业客户所需的配方、实验、工艺、合规等管理，实现企业知识沉淀和研发创新</div>
    <div class="advantage-list flex-box">
      <mobile-tab-fold :tabs="foldTabs" :value="activeVal" @input="onFoldTab" />
      <div class="mobile-tab-desc" v-if="schemeInfo.description">{{ schemeInfo.description }}</div>
      <div class="list">
        <div 
          class="list-item" 
          :class="{'is-active': activeVal === item.val}"
          v-for="(item, k) in topList" 
          :key="k" 
          @click="schemeClick(item)"
        >
          <div class="item-title">{{ item.title }}</div>
          <div class="item-description">{{ item.description }}</div>
          <div class="item-backg"></div>
        </div>
      </div>
      <div class="content">
        <el-image
          class="preview-shot"
          fit="contain"
          :src="schemeInfo.contentImg"
          :preview-src-list="previewImgs"
        />
      </div>
    </div>

  </div>
</template>

<script>
import MobileTabFold from '@/components/MobileTabFold/index.vue'
import ptgy1 from '@/assets/images/ptgy1.png'
import ptgy2 from '@/assets/images/ptgy2.png'
import ptgy3 from '@/assets/images/ptgy3.png'

export default {
  components: { MobileTabFold },
  data() {
    return {
      schemeInfo: {},
      
      topList: [
        {
          val: '01',
          title: '璞华易研PLM（化工材料）平台概要',
          description: '璞华易研PLM（化工材料）平台贯穿新材料市场需求、设计、实验、中试、小批量、放量、优化、运营等环节',
          contentImg: ptgy1,
        },
        {
          val: '02',
          title: '璞华易研PLM（化工材料）平台主要管理对象',
          description: '璞华易研PLM（化工材料）平台覆盖配方、成本、实验、资源、模版、规范、物料、报表、需求、流程、模型、权限等方面的管理',
          contentImg: ptgy2,
        },
        {
          val: '03',
          title: '材料研发管理平台的功能俯瞰图',
          description: '璞华易研PLM材料研发管理平台可以分为核心管理模块、业务延伸模块、效率工具模块、基础功能模块和后台支撑模块',
          contentImg: ptgy3,
        }
      ],
      activeVal: '01',
    }
  },
  created() {
    this.schemeInfo = this.topList[0]
  },
  computed: {
    previewImgs() {
      return this.topList.map(item => item.contentImg).filter(Boolean)
    },
    foldTabs() {
      return this.topList.map(item => ({
        name: item.val,
        label: item.title
      }))
    }
  },
  methods: {
    schemeClick(item) {
      this.schemeInfo = item
      this.activeVal = item.val
    },
    onFoldTab(name) {
      const item = this.topList.find(entry => entry.val === name)
      if (item) this.schemeClick(item)
    }
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.platform-overview {
  padding: 9rem 18.2rem 10.1rem;
  background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 7.2rem;
  }

  .advantage-list {
    width: 100%;
    .mobile-tab-desc {
      display: none;
    }
    .list {
      margin-right: 3.2rem;
      .list-item {
        width: 40rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.3);
        padding: 3.6rem 3.6rem 3rem;
        cursor: pointer;
        position: relative;
        margin-bottom: 2.4rem;
        .item-title {
          line-height: 2.8rem;
          font-size: 2.2rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          margin-bottom: 1.6rem;
        }
        .item-description {
          font-size: 1.6rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 2.2rem;
        }
        .item-backg {
          position: absolute;
          width: 12.56rem;
          height: 9.98rem;
          right: 0;
          bottom: 0;
        }
        &.is-active {
          background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
          .item-title {
            color: #FFFFFF;
          }
          .item-description {
            color: #FFFFFF;
          }
          .item-backg {
            background: url('#{$img}/bj3.png');
            background-size: 100% 100%;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .content {
    width: 112.3rem;
    height: 61rem;
    img,
    ::v-deep .preview-shot {
      width: 100%;
      height: 100%;
      display: block;
      cursor: zoom-in;
    }
    ::v-deep .preview-shot .el-image__inner {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .platform-overview {
    padding: 4.8rem 1.6rem;
    height: auto;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 2.4rem;
      text-align: center;
    }
    .advantage-list {
      flex-wrap: wrap;
      width: 100%;
      .list {
        display: none;
      }
      ::v-deep .mobile-tab-fold {
        padding: 0;
        margin: 0 0 0.8rem;
        flex: 1 1 100%;
        width: 100%;
        max-width: 100%;
      }
      .mobile-tab-desc {
        display: block;
        flex: 1 1 100%;
        width: 100%;
        margin: 0 0 1.6rem;
        font-size: 1.4rem;
        line-height: 2.2rem;
        color: #666A77;
        text-align: left;
        word-break: break-word;
      }
    }
    .content {
      width: 100%;
      height: auto;
      img,
      ::v-deep .preview-shot,
      ::v-deep .preview-shot .el-image__inner {
        height: auto;
      }
    }
  }
}
</style>
